import type { ComponentSchema } from "../../../../../schema-types";
import { SLIDE_SCHEMA, SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "hero",
  label: "Hero Section",
  description: "The main attention-grabbing section at the top of the page.",
  supportedPages: ["home", "categories"],
  variants: [
    {
      id: "v1",
      label: "V1 — Arched triptych",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v2",
      label: "V2 — Centred arch",
      fields: [
        { key: "slides", label: "Slides", type: "array", itemSchema: SLIDE_SCHEMA },
        { key: "autoplay", label: "Auto Play", type: "boolean", default: true },
        { key: "autoplayDelay", label: "Auto Play Interval (ms)", type: "number", default: 5000 },
      ],
    },
    {
      id: "v3",
      label: "V3 — Stitched frame",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: SLIDE_SCHEMA },
      ],
    },
    {
      id: "v4",
      label: "V4 — Raat (dark stitched frame)",
      fields: [
        { key: "slides", label: "Slides (first slide used)", type: "array", itemSchema: SLIDE_SCHEMA },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
